import {Component, Mixins, Ref, Vue, Watch} from 'vue-property-decorator';
import JudgementListDataMixin from '@/components/product/judgement/JudgementListDataMixin';
import {CategroyType, FilterDataType, GetGridJudgementResponse, NewDisplayEnum} from '@/types/judgement';
import {getDownToday, momentAdd} from '@/utils/dateUtils';
import {escapeHtml, getProductsConfigurationsByAllMall} from '@/utils/commonUtils';

import {gridModelToExcel, ncpPopup} from '@/utils/ncp';
import {writeExcel} from '@/utils/excel';
import {namespace} from 'vuex-class';
import store from '@/store';
import PageDateRangePicker from '@/components/board/common/PageDateRangePicker.vue';

const productModule = namespace('product');

window.addEventListener(
  'message',
  function(event: any): void {
    if (typeof event === 'object' && event.data) {
      if (event.data.batchConfirm) {
        let result = '';
        const {type, failures, successNos, totalCount} = event.data.data;
        let typeTitle = type == 'CONFIRM' ? window.$t('PRODUCT_JUDGEMENT_TITLE_CONFIRM') : window.$t('PRODUCT_JUDGEMENT_TITLE_REJECT');
        let headerHtml = '<tr><th>' + window.$t('PRODUCT_JUDGEMENT_HEADER1') + '</th><th>' + window.$t('PRODUCT_JUDGEMENT_HEADER2') + '</th></tr>';
        let failureCount = failures.length;
        let successCount = successNos.length;

        if (successCount > 0) {
          let content = `<div class="table_tit_area no-border">
                                        <div class="table_tit">${typeTitle}</div>
                                    </div>
                                    <div class="description">
                                        ${window.$t('PRODUCT_JUDGEMENT_ITEM')} <span class="highlight">${totalCount}</span>${window.$t(
            'PRODUCT_JUDGEMENT_AMONG_THE_PRODUCTS'
          )} <span class="highlight">${successCount}</span>${window.$t('PRODUCT_JUDGEMENT_PRODUCT_INFORMATION_OF_EACH_PRODUCT_HAS_BEEN_CHANGED')}
                                    </div>
                                    <table class="ncp_tbl">
                                        <tbody>
                                            ${headerHtml}`;

          for (let i = 0; i < successCount; i++) {
            content = content.concat(`<tr><td>${successNos[i]}</td><td>${window.$t('PRODUCT_JUDGEMENT_HAS_BEEN_CHANGED')}</td></tr>`);
          }
          content = `${content}</tbody></table>`;

          result = `${result}${content}`;
        }

        if (failureCount > 0) {
          let content = `<div class="table_tit_area no-border">
                                        <div class="table_tit">${window.$t('PRODUCT_JUDGEMENT_CANNOT_BE_JUDGED')}</div>
                                    </div>
                                    <div class="description">
                                        ${window.$t('PRODUCT_JUDGEMENT_ITEM')} <span class="highlight">${totalCount}</span>${window.$t(
            'PRODUCT_JUDGEMENT_AMONG_THE_PRODUCTS'
          )} <span class="highlight">${failureCount}</span>${window.$t('PRODUCT_JUDGEMENT_PRODUCT_INFORMATION_OF_EACH_PRODUCT_CANNOT_BE_CHANGED')}
                                    </div>
                                    <table class="ncp_tbl">
                                        <tbody>
                                            ${headerHtml}`;

          for (let mallProductNo in failures) {
            content = content.concat(`<tr><td>${mallProductNo}</td><td>${failures[mallProductNo]}</td></tr>`);
          }
          content = `${content}</tbody></table>`;

          result = `${result}${content}`;
        }

        store.commit('terms/SET_POPINFO', {
          title: window.$t('PRODUCT_PRODUCTLIST_PLM_BATCH_CHANGE_RESULT'), //일괄변경 결과,
          subStyle: 'width:900px; max-height:850px; scroll-y:auto',
          footBtn: true,
          noticeBox: result
        });
        store.commit('terms/SET_NCPLAYERISSHOW', true);
        store.commit('product/SET_SEARCHJUDGEMENTLIST', true);
      }
    }
    if (event.data.productJudgement === true || event.data.batchConfirm === true) {
      store.commit('product/SET_SEARCHJUDGEMENTLIST', true);
    }
  },
  false
);

@Component
export default class JudgementListMethodsMixin extends Mixins(JudgementListDataMixin) {
  @productModule.Mutation('SET_SEARCHJUDGEMENTLIST') public setIsSearch!: (isSearch: boolean) => void;
  @productModule.Getter('getIsSearchJudgmentList') public isEmitSearch!: boolean;

  @Ref()
  protected readonly dateRangePickerRef!: PageDateRangePicker;

  private excelColumns: any[];

  @Watch('isEmitSearch')
  public onIsSearchChange(val: any): void {
    if (val) {
      this.search(this.gridProps.pageOptions.page);
    }
  }

  public search(page: number = 1): void {
    this.$nextTick((): void => {
      const params: {[propName: string]: any} = {};

      Object.keys(this.searchParams).forEach((prop: any): void => {
        if (this.searchParams[prop] !== -100 && this.searchParams[prop] !== '') {
          Object.assign(params, {[prop]: this.searchParams[prop]});
        }
      });

      Object.assign(params, {
        searchStartDate: this.dateReceiveData.startYmd,
        searchEndDate: this.dateReceiveData.endYmd,
        page
      });

      let keywords = params['keywords']?.trim() || '';
      if (params['keywordType'] === 'MALL_PRODUCT_NO') {
        keywords = keywords
          .replace(/\r\n|\n/g, ',')
          .split(',')
          .filter((v: any): boolean => v.length > 0);
        keywords = keywords.map((el: any): void => el.trim());
        let flag: boolean;
        flag = keywords.some((v: any): boolean => {
          return /^\d+$/.test(v) === false;
        });
        if (flag) {
          this.invalidKeywordSwitch = true;
          this.invalidKeywordText = this.toI18n('PRODUCT_PRODUCT_KEYWORD_TYPE');
          return;
        }

        params['keywords'] = keywords.join(',');
      } else if (params['keywordType'] === 'PRODUCT_NAME') {
        if (/^\d{9}$/.test(keywords)) {
          params['keywordType'] = 'MALL_PRODUCT_NO';
        }
      } else if (params['keywordType'] === 'PRODUCT_MANAGEMENT_CD') {
        const selectedData = this.filterDateData.find((item: FilterDataType): any => item.selected);
        if (selectedData?.value === 'ALL' && !keywords.length) {
          this.invalidKeywordSwitch = true;
          this.invalidKeywordText = this.toI18n('PRODUCT_PRODUCT_KEYWORD_INPUT');
          return;
        }
      }

      const tuiGrid = (this.$refs.gridArea as any).$refs.tuiGrid;
      tuiGrid.invoke('setColumns', this.gridProps.columns);

      this.$api.getProductsApprovalWaiting({params} as any).then(({data}: any): any => {
        for (let i = 0; i < data.contents.length; i++) {
          data.contents[i].saleDateTime = data.contents[i].saleStartDateTime + ' ~ ' + data.contents[i].saleEndDateTime;
        }
        this.judgementContents = Object.assign({}, data);
        this.gridProps.pageOptions.perPage = this.searchParams.size || 0;
        this.gridProps.pageOptions.page = page;
        this.gridProps.pageOptions.totalCount = data.totalCount;
        store.commit('product/SET_SEARCHJUDGEMENTLIST', false);
      });
    });
  }

  public get currentDateRange(): string {
    const selectVal: FilterDataType = this.filterDateData.find((data: FilterDataType): any => data.selected) || {
      value: '0',
      label: this.toI18n('BOARD_FAQ_TODAY'),
      selected: true
    };
    return selectVal.value;
  }

  public dateData: {startYmd: string; endYmd: string} = {
    startYmd: '',
    endYmd: this.today
  };
  public dateReceiveData = {...this.dateData};

  private setStartYmd(): void {
    if (this.dateReceiveData.endYmd) {
      Object.assign(this.dateData, {
        startYmd: momentAdd(this.dateReceiveData.endYmd, this.filterDateMapping[this.currentDateRange], 'YYYY-MM-DD'),
        endYmd: this.dateReceiveData.endYmd
      });
    } else {
      Object.assign(this.dateData, {
        startYmd: momentAdd(this.today, this.filterDateMapping[this.currentDateRange], 'YYYY-MM-DD'),
        endYmd: this.today
      });
    }

    this.dateReceiveData = {...this.dateData};
  }

  public keywordInfoChange(): void {
    const keywordInfoType = this.searchParams['keywordInfo.type'];
    this.keywordTexthide = keywordInfoType !== 'PRODUCT_MANAGEMENT_CD_LIKE';

    if (this.filterDateData.length === 6 && keywordInfoType === 'PRODUCT_MANAGEMENT_CD') {
      this.filterDateData.push({value: 'ALL', label: '전체', selected: false});
    } else {
      if (this.filterDateData.length > 6) {
        this.filterDateData.pop();
      }
      if (!this.dateReceiveData.startYmd && !this.dateReceiveData.endYmd) {
        this.dateFilterChange(3);
      }
    }
  }

  public dateFilterChange(idx: number): void {
    this.setFilterUnSelected();
    Vue.set(this.filterDateData, idx, {...this.filterDateData[idx], selected: true});

    // 퀵버튼을 클릭했을 때 종료일을 항상 오늘 기준으로 세팅
    this.dateReceiveData = {
      ...this.dateReceiveData,
      endYmd: this.today
    }

    this.setYmd();
  }

  public setFilterUnSelected(): void {
    const oldIdx = this.filterDateData.findIndex((item: FilterDataType): any => item.selected);
    Vue.set(this.filterDateData, oldIdx, {...this.filterDateData[oldIdx], selected: false});
  }

  public searchMenuBlur(elName: any): void {
    if (elName === 'partner' && this.partnerInputVal.length && this.partnerList.length) {
      if (!this.partnerList.find((item): any => item.partnerName === this.partnerInputVal)) {
        this.partnerInputVal = '';
        this.searchParams['partnerNo'] = -100;
      }
    } else if (elName === 'admin' && this.adminInputVal.length && this.adminList.length) {
      if (!this.adminList.find((item): any => item.name === this.adminInputVal)) {
        this.adminInputVal = '';
        this.searchParams['adminNo'] = -100;
      }
    }
  }

  public searchMenuFocus(elName: any, event: any): void {
    if (!this.searchParams.mallNo) {
      event.currentTarget.blur();
      alert(this.ALERT_MESSAGES.chooseMall);
    } else {
      if (elName === 'partner' && this.partnerInputVal.length) {
        this.partnerMenuIsShow = true;
      }
      if (elName === 'admin' && this.adminInputVal.length) {
        this.adminMenuIsShow = true;
      }
    }
  }

  public searchMenuInput(elName: any): void {
    const params = {
      mallNo: this.searchParams.mallNo
    };
    if (elName === 'partner') {
      if (!this.partnerList.length) {
        this.$api.getMallsContractedPartnersByMallNo({pathParams: params}).then(({data}): void => {
          this.partnerList = data.filter(item => {
            return item.partnerStatus === 'ACTIVE' && ( item.contractStatus === 'ACTIVE' || item.contractStatus === 'SUSPEND' );
          });
          this.partnerMenuIsShow = true;
        });
      } else {
        this.partnerMenuIsShow = true;
      }
    } else if (elName === 'admin') {
      if (!this.adminList.length) {
        this.$api.getAdminsServiceMerchandisers({params: params}).then(({data}): void => {
          this.adminList = data;
          this.adminMenuIsShow = true;
        });
      } else {
        this.adminMenuIsShow = true;
      }
    }
  }

  public searchMenuSelected(valueName: 'adminNo' | 'partnerNo', item: NewDisplayEnum): void {
    this.searchParams[valueName] = Number(item.value);
    if (valueName === 'adminNo') {
      this.adminInputVal = item.text;
      this.adminMenuIsShow = false;
    } else if (valueName === 'partnerNo') {
      this.partnerInputVal = item.text;
      this.partnerMenuIsShow = false;
    }
  }

  public mallNoChange(): void {
    this.partnerInputVal = '';
    this.searchParams['partnerNo'] = -100;
    this.adminInputVal = '';
    this.searchParams['adminNo'] = -100;
  }

  public adminSearchMenuClose(): void {
    this.adminMenuIsShow = false;
  }
  public partnerSearchMenuClose(): void {
    this.partnerMenuIsShow = false;
  }

  private setYmd(): void {
    if (this.currentDateRange === '0') {
      Object.assign(this.dateData, {
        startYmd: this.today,
        endYmd: this.today
      });
    } else if (this.currentDateRange === 'ALL') {
      Object.assign(this.dateData, {
        startYmd: '2000-01-01',
        endYmd: this.today
      });
    } else {
      this.setStartYmd();
    }
    this.dateReceiveData = {...this.dateData};
  }

  public applyStatusTypeChange(): void {
    const applyStatusType = this.searchParams['applyStatusType'];
    switch (applyStatusType) {
      case 'REGISTRATION_READY':
      case 'APPROVAL_READY':
      case 'APPROVAL_REJECTION':
      case 'SALE_AGREEMENT_READY':
      case 'SALE_AGREEMENT_REJECTION':
        this.isAllCheckBoxDisabled = true;
        break;
      case 'ALL':
      case 'FINISHED':
      case 'AFTER_APPROVAL_READY':
      case 'AFTER_APPROVAL_REJECTION':
        this.isAllCheckBoxDisabled = false;
        break;
    }
  }

  public categoriesDataHandle(array: []): CategroyType[] {
    if (array.length) {
      return array.map(
        (item: any): CategroyType => {
          const value = item.displayCategoryNo || item.categoryNo;
          const label = item.displayCategoryName || item.name;
          const children = this.categoriesDataHandle(item.children || item.child);
          return {value, label, children};
        }
      );
    } else {
      return [];
    }
  }

  public commissionTypeChange(): void {
    this.isSupplyPriceViewShow = false;
    this.isCommissionRateView = false;
    const commissionType = this.searchParams['commission.type'];
    switch (commissionType) {
      case 'RATE':
        this.isCommissionRateView = true;
        break;
      case 'SUPPLY_PRICE':
        this.isSupplyPriceViewShow = true;
        break;
    }
  }

  public pageSizeChange(): void {
    this.$nextTick((): void => {
      this.search();
    });
  }

  public fireExcelDown(): void {
    const data = this.judgementContents.contents || [];
    if (data.length === 0) {
      alert(this.$t('COMMON_NOT_DATA'));
    } else {
      const model = gridModelToExcel(this.excelColumns);
      model.formatter['applyStatus'] = ({row}: any): any => {
        let text = '';
        switch (row.applyStatus) {
          case 'APPROVAL_READY':
            text = this.toI18n('PRODUCT_PRODUCT_APPROVAL_WAIT');
            break;
          case 'AFTER_APPROVAL_READY':
            text = this.toI18n('PRODUCT_PRODUCT_APPROVAL_WAIT_MODIFY');
            break;
        }
        return text;
      };
      model.formatter['productName'] = ({value}: any): string => {
        return escapeHtml(value);
      };
      model.formatter['brandName'] = ({value}: any): string => {
        return escapeHtml(value);
      };
      model.formatter['commissionRate'] = ({row}: any): string => {
        return `${row.commissionRate}%`;
      };
      model.formatter['adminName'] = ({row}: any): string => {
        return `${row.representativeName}`;
      };
      model.formatter['mallProductNo'] = ({row}: any): string => {
        return `${row.productNo}`;
      };
      model.formatter['productManagementCd'] = ({row}: any): string => {
        return `${row.managementCode}`;
      };
      model.formatter['updateYmdt'] = ({row}: any): string => {
        return `${row.approvalRequestedDateTime}`;
      };
      model.formatter['registerYmdt'] = ({row}: any): string => {
        return `${row.registerDateTime}`;
      };
      model.formatter['salePeriod'] = ({row}: any): string => {
        return `${row.saleDateTime}`;
      };

      const excelColumn: any = {};

      if (this.excelColumns.length === 0) {
        this.defaultDisplayOrder.forEach((column: any): void => {
          excelColumn[column.columnName] = column.columnName;
        });
      } else {
        this.excelColumns.forEach((column: any): void => {
          excelColumn[column.name] = column.header;
        });
      }
      const filename = 'product_' + getDownToday();
      writeExcel(data, excelColumn, filename, model.formatter);
    }
  }

  private gridExcelColumnsData(): void {
    this.$api.getGridLayouts({params: {gridName: 'PRODUCT_JUDGEMENT_GRID'}}).then(({data}): any => {
      let gridData = [];
      for (let i = 0; i < data.length; i++) {
        gridData.push({
          name: data[i].columnName,
          header: this.getDisplayName(data[i].columnName)
        });
      }
      this.excelColumns = gridData;
    });
  }

  private getDisplayName(str: string): string {
    switch (str) {
      case 'applyStatus':
        str = this.getStr('PRODUCT_PRODUCT_ADMIT_STATUS');
        break;
      case 'mallName':
        str = this.getStr('PRODUCT_PRODUCT_MALL_NAME');
        break;
      case 'productNo':
        str = this.getStr('PRODUCT_PRODUCT_MALL_PRODUCT_NO');
        break;
      case 'productName':
        str = this.getStr('PRODUCT_PRODUCT_PRODUCT_NAME');
        break;
      case 'managementCode':
        str = this.getStr('PRODUCT_PRODUCT_PRODUCT_MANAGEMENT_CD');
        break;
      case 'brandName':
        str = this.getStr('PRODUCT_PRODUCT_BRAND');
        break;
      case 'partnerName':
        str = this.getStr('PRODUCT_PRODUCT_PARTNER_NAME');
        break;
      case 'adminName':
        str = this.getStr('PRODUCT_PRODUCT_ADMIN_NAME');
        break;
      case 'commissionRate':
        str = this.getStr('PRODUCT_PRODUCT_COMMISSION_RATE');
        break;
      case 'saleDateTime':
        str = this.getStr('PRODUCT_PRODUCT_SALE_PERIOD');
        break;
      case 'approvalRequestedDateTime':
        str = this.getStr('PRODUCT_PRODUCT_APPROVAL_REQUESTED_DATETIME');
        break;
      case 'registerDateTime':
        str = this.getStr('PRODUCT_PRODUCT_PRODUCT_REGISTER');
        break;
    }

    return str;
  }

  private getStr(str: string): string {
    return '' + this.$t(str);
  }

  public saleMethodTypeChange(): void {
    const saleMethodType = this.searchParams['saleMethodType'];
    this.isCommissionTypeDisabled = saleMethodType === 'PURCHASE';
  }

  public onClickSummarySearch(selectedSummary: string): void {
    this.reset();
    Object.assign(this.dateData, {
      startYmd: '2000-01-01',
      endYmd: this.today
    });

    const data = {...this.dateData, isBtnSet: false};
    this.dateDataChange(data);

    switch (selectedSummary) {
      case 'TOTAL':
        this.searchParams['applyStatus'] = 'APPROVAL_READY,AFTER_APPROVAL_READY';
        break;
      case 'ONSALE':
        this.searchParams['applyStatus'] = 'APPROVAL_READY';
        break;
      case 'READY':
        this.searchParams['applyStatus'] = 'AFTER_APPROVAL_READY';
        break;
    }
    this.$nextTick((): void => {
      this.search();
    });
  }

  public reset(): void {
    this.searchParams = {...this.searchParamsResetData};
    this.isAllCheckBoxDisabled = false;
    this.isCommissionTypeDisabled = false;
    this.isSupplyPriceViewShow = false;
    this.isCommissionRateView = false;
    this.customProperties = [];
    this.dateFilterChange(3);
    this.setStartYmd();
  }

  public dateDataChange({startYmd, endYmd, isBtnSet}: any): void {
    if (!isBtnSet) {
      this.setFilterUnSelected();
      // 퀵버튼을 클릭하면 이벤트 실행 순서가 dateFilterChange -> dateDataChange 순서로 실행되기 때문에
      // 퀵버튼으로 날짜를 변경하여도 이전 날짜로 세팅되는 이슈가 있어 퀵버튼이 아닌 경우에만 dateReceiveData 를 갱신하도록 코드 옮김
      this.dateReceiveData = {startYmd, endYmd};
    }
    // 변경된 날짜로 업데이트를 하지 않으면, 수동으로 종료 일자를 선택 한 후, 오늘 버튼을 클릭하면 시작 일자가 변경되지 않음
    this.dateRangePickerRef.onDateObjectChange(this.dateReceiveData);
  }

  public created(): void {
    this.setPopIsExist(true);
    this.$api.getProductsStatusInspections().then(({data}): void => {
      this.judgementSummaries = Object.assign({}, data);
    });

    this.getGridDataLayer(({data}: GetGridJudgementResponse): void => {
      if (data.length === 0) {
        Object.assign(data, {...this.defaultDisplayOrder});
      }
      for (let i = 0; i < data.length; i++) {
        this.getGridLayouts[i] = this.gridRefactory(data[i].columnName, data[i].visible);
      }
      Object.assign(this.gridProps.columns, this.getGridLayouts);
      this.search();
    });

    this.setStartYmd();
    this.gridExcelColumnsData();

    this.$eventBus.$on('UPDATE-COLUMN-CONFIG-JUDGEMENT', (): void => {
      this.getGridDataLayer(({data}: GetGridJudgementResponse): void => {
        for (let i = 0; i < data.length; i++) {
          this.getGridLayouts[i] = this.gridRefactory(data[i].columnName, data[i].visible);
        }
        this.gridProps.columns = this.getGridLayouts;
        this.search();
      });
    });

    getProductsConfigurationsByAllMall().then((responses: any): void => {
      responses.forEach((item: any): void => {
        this.productDetailUrlObj[item.mallNo] = item.productDetailUrl;
      });
    });
  }

  public getGridDataLayer(callback: any): any {
    this.$api.getGridLayouts({params: {gridName: 'PRODUCT_JUDGEMENT_GRID'}}).then(callback);
  }

  public mounted(): void {
    this.categoiesCascade = this.$refs.categoiesCascade as any;
  }

  public handleGridClick(productNo: number): void {
      const popup = ncpPopup(`/product/judgement/${productNo}`, 'approvalReady', 900, 1000);

      popup.addEventListener('message', ({ origin, data }: MessageEvent): void => {
        if ((origin === process.env.VUE_APP_ADMIN_REMOTE_URL) && data === 'SUCCESS') {
            this.search();
        }
      });
  }
}
